import { Box, ThemeProvider, Theme, StyledEngineProvider } from '@mui/material';
import Button from '@ui/Button';
import getConfig from 'next/config';
import React from 'react';
import Typography from '@ui/Typography';
import { theme } from '../../theme';
import Modal from '../Modal';
import { FallbackRender } from './SentryErrorBoundary';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const { WEB_URI } = getConfig().publicRuntimeConfig;

const Fallback: FallbackRender = ({ error }) => {
  return (
    <StyledEngineProvider injectFirst>
      (
      <ThemeProvider theme={theme}>
        <Modal
          open
          ModalBodyPaperProps={{
            includeMaxWidth: true,
            includeDismissIcon: false,
            onClose: () => {},
          }}
          onClose={() => {}}
        >
          {/* NOTE: this is a specific edge case where the user subscription is invalid */}
          {error.message === 'data.user.subscription is null' ? (
            <Typography variant="pMd">
              {`It looks like we are still provisioning your account. \
              If you believe this to be an error, please contact support.`}
            </Typography>
          ) : (
            <Typography variant="pMd">
              {`Oops, something went wrong! Please try reloading and/or \
            contacting support for assistance. `}
              <a
                href={`mailto:support@wellsaidlabs.com?subject=WellSaid Studio Error Report&body=${
                  error
                    ? `I encountered the following error while using the WellSaid Studio:\
                     %0D%0A[${error.name}] ${error.message}
                     %0D%0A[UserAgent] ${window.navigator.userAgent}
                     `
                    : ''
                }`}
              >{`support@wellsaidlabs.com`}</a>
            </Typography>
          )}
          <Box marginTop={4}>
            <Button
              variant="primary"
              fullWidth
              href={WEB_URI}
            >{`Back to home page`}</Button>
          </Box>
        </Modal>
      </ThemeProvider>
      )
    </StyledEngineProvider>
  );
};

export default Fallback;
